import React from 'react'

import { Accordion } from 'shared-global-ec-uikit/components/dist/react/esm/components/accordion'
import { CheckboxGroup } from 'shared-global-ec-uikit/components/dist/react/esm/components/checkbox-group'
import { Checkbox } from 'shared-global-ec-uikit/components/dist/react/esm/components/checkbox'
import { CollectionList } from 'shared-global-ec-uikit/components/dist/react/esm/components/collection-list'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { Keylines } from './typings'
import { RadioGroup } from 'shared-global-ec-uikit/components/dist/react/esm/components/radio-group'
import { Radio } from 'shared-global-ec-uikit/components/dist/react/esm/components/radio'
import { Filters as FiltersProp } from './typings'
import { storeSizeFilters, filterTranslationMap } from '../constants'
import getConstants from '../../../../constants'
import { BRAND_LIST } from 'typings'

type Props = {
  filters: FiltersProp
  onFilter: (filters: { [key: string]: boolean | string }) => void
  id: string
  keylines?: Keylines
}

const Filters: React.FC<Props & WrappedComponentProps> = props => {
  const {
    intl,
    filters: {
      departmentFilters,
      selectedStoreSizeFilter,
      accessFilters,
      storeServiceFilters,
    },
    onFilter,
    id,
    keylines,
  } = props

  const filterOnChange = (filter: string, setTo: boolean | string) => {
    onFilter({
      [filter]: setTo,
    })
  }

  return (
    <div className="fr-ec-mb-spacing-06">
      <CollectionList keylines={keylines}>
        {getConstants().BRAND === BRAND_LIST.PL ? null : (
          <Accordion
            element="fieldset"
            label={intl.formatMessage({
              id: 'text_store_locator_filter_store_type',
            })}
            labelElement="h1"
            variant="default"
            labelChildren=""
          >
            <RadioGroup legend="">
              {storeSizeFilters.map(({ value, translationKey }) => (
                <Radio
                  label={intl.formatMessage({ id: translationKey })}
                  checked={value === selectedStoreSizeFilter}
                  onChange={() => filterOnChange('storeSize', value)}
                  value={value}
                  id={`${value}-${id}`}
                  key={`${value}-${id}`}
                />
              ))}
            </RadioGroup>
          </Accordion>
        )}
        <Accordion
          element="fieldset"
          label={intl.formatMessage({
            id: 'text_store_locator_filter_product',
          })}
          labelElement="h1"
          variant="default"
          labelChildren=""
        >
          <CheckboxGroup legend="">
            {Object.entries(departmentFilters).map(
              ([filter, isSet]: [string, boolean]) => (
                <Checkbox
                  label={intl.formatMessage({
                    id: filterTranslationMap[filter],
                  })}
                  checked={isSet}
                  onChange={() => filterOnChange(filter, !isSet)}
                  value={filter}
                  id={`${filter}-${id}`}
                  key={`${filter}-${id}`}
                />
              ),
            )}
          </CheckboxGroup>
        </Accordion>
        {getConstants().SHOW_STORE_SERVICE_FILTER[getConstants().BRAND] ? (
          <Accordion
            element="fieldset"
            label={intl.formatMessage({
              id: 'text_store_locator_store_service',
            })}
            labelElement="h1"
            variant="default"
            labelChildren=""
          >
            <CheckboxGroup legend="">
              {Object.entries(storeServiceFilters).map(
                ([filter, isSet]: [string, boolean]) => (
                  <Checkbox
                    label={intl.formatMessage({
                      id: filterTranslationMap[filter],
                    })}
                    checked={isSet}
                    onChange={() => filterOnChange(filter, !isSet)}
                    value={filter}
                    id={`${filter}-${id}`}
                    key={`${filter}-${id}`}
                  />
                ),
              )}
            </CheckboxGroup>
          </Accordion>
        ) : null}
        <Accordion
          element="fieldset"
          label={intl.formatMessage({ id: 'text_parkinglot' })}
          labelElement="h1"
          labelChildren=""
          variant="default"
        >
          <CheckboxGroup legend="">
            {Object.entries(accessFilters).map(([filter, isSet]: any) => (
              <Checkbox
                label={intl.formatMessage({ id: filterTranslationMap[filter] })}
                checked={isSet}
                name={`${filter}-${id}`}
                onChange={() => filterOnChange(filter, !isSet)}
                value={filter}
                id={`${filter}-${id}`}
                key={`${filter}-${id}`}
              />
            ))}
          </CheckboxGroup>
        </Accordion>
      </CollectionList>
    </div>
  )
}

export default injectIntl(Filters)
